<script lang="ts">
  import { tick } from 'svelte';

  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { IconType } from '$shared/constants/IconType';
  import WithList from '$shared/molecules/WithList/WithList.svelte';
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';

  interface Props {
    list?: CommonList[];
    loading?: boolean;
    disabled?: boolean;
    hasOverflow?: boolean;
    onclick?: (detail: any) => void;
  }

  let { list = [], loading = false, disabled = false, hasOverflow = false, onclick }: Props = $props();

  let parent: HTMLElement = $state();
  let withListElement: WithList = $state();
  let showList = $state(false);

  const onClickShowList = async (): Promise<void> => {
    showList = true;
    await tick();
    withListElement?.setScrollListener();
  };

  const hideList = (): void => {
    showList = false;
  };

  const onClickList = (detail: any): void => {
    hideList();
    onclick?.(detail);
  };

  const onClickWindow = (e: any): void => {
    if (parent && !parent.contains(e.target)) {
      hideList();
    }
  };
</script>

<svelte:window onmouseup={onClickWindow} />

<div bind:this={parent} class="comp-menu">
  {#if loading}
    <Spinner />
  {:else}
    <WithList
      bind:this={withListElement}
      {hasOverflow}
      {list}
      show={showList}
      onclick={onClickList}
      onclose={hideList}
      onopen={onClickShowList}
    >
      <div class="icon" class:active={showList}>
        <Icon
          {disabled}
          type={IconType.Button}
          name="more"
          value="icon-more-horizontal {showList ? 'active' : ''}"
          onclick={onClickShowList}
        />
      </div>
    </WithList>
  {/if}
</div>

<style>
  .active {
    background-color: var(--light-blue);
    border-radius: 3px;
  }
</style>
